

export default function Details({ PropertyObject }) {

  const items = [
    { label: "ID:", content: PropertyObject.PropertyGeneratedId ? PropertyObject.PropertyGeneratedId : null },
    { label: "Property For:", content: PropertyObject.PropertyFor ? PropertyObject.PropertyFor : null },
    { label: "Bedrooms:", content: PropertyObject.NoofRoom ? PropertyObject.NoofRoom : null },
    { label: "Washrooms:", content: PropertyObject.NoofWashroom ? PropertyObject.NoofWashroom : null },
    { label: "Price:", content: PropertyObject.PropertyFor == "Sell" ? PropertyObject.ExpectedPrice + '/- ' + PropertyObject.ExpectedPricePerUnit : null },
    { label: "Booking Amt.:", content: PropertyObject.PropertyFor == "Sell" ? PropertyObject.BookingAmount + '/-' : null },
    { label: "Maintenance:", content: PropertyObject.PropertyFor == "Sell" && PropertyObject.Maintenance ? PropertyObject.Maintenance + '/-' : null },
    { label: "Rent:", content: PropertyObject.PropertyFor == "Rent" || PropertyObject.PropertyFor == "PG" ? PropertyObject.RentPerMonth + '/-' + 'per Month' : null },
    { label: "Property Age:", content: PropertyObject.AgeofProperty ? PropertyObject.AgeofProperty : null },
    { label: "Ownership:", content: PropertyObject.OwnershipStatus ? PropertyObject.OwnershipStatus : null },
    { label: "Facing:", content: PropertyObject.Facing ? PropertyObject.Facing : null },
    { label: "Posession By:", content: PropertyObject.PossessionBy ? PropertyObject.PossessionBy : null },
    { label: "Property Floor:", content: PropertyObject.PropertyOnTheFloor ? PropertyObject.PropertyOnTheFloor : null },
    { label: "Parking:", content: PropertyObject.Parking ? PropertyObject.Parking : null },
    { label: "Room Type:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.RoomType : null },
    { label: "Food Meal:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.FoodMeal : null },
    { label: "Suitable For:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.SuitableFor : null },
    { label: "Available:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.PGAvailableFor : null },
    { label: "Notice Period:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.NoticePeriod : null },
    { label: "Food Charges Included:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.FoodChargesIncluded : null },
    { label: "Electricity Charges Included:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.ElectricityChargesIncluded : null },
    { label: "Security Deposit:", content: PropertyObject.PropertyFor == "PG" ? PropertyObject.SecurityDeposit + "/-" : null },
  ];

  console.log("PropertyObject in Details component:", PropertyObject);

  return (
    <>
      <h5 className="title fw-6">Property Details</h5>
      <div className="row">
        {items.map(
          (item, index) =>
            item.content && (
              <div className="col-md-6" key={index}>
                <div className="inner-box">
                  <span className="label text-black-3">{item.label}</span>
                  <div className="content text-black-3">{item.content}</div>
                </div>
              </div>
            )
        )}
      </div>
    </>
  );
}
